import { useState } from 'react';

import type { SeasonalThemeOption } from '@components/branding';

import { useSeasonalTheme } from 'features/seasonal-theme';

const OCTOBER = 9;
const NOVEMBER = 10;

/** 1 October to 1 November inclusive, in the viewer's local time. */
export const isHalloweenSeason = (date: Date) => {
  const month = date.getMonth();
  return month === OCTOBER || (month === NOVEMBER && date.getDate() === 1);
};

export const isHalloweenSigninEnabled = ({
  now,
  seasonalTheme,
}: {
  now: Date;
  seasonalTheme: SeasonalThemeOption;
}) => {
  return seasonalTheme === 'halloween' && isHalloweenSeason(now);
};

/**
 * Whether the sign-in page wears its Halloween costume: the seasonal theme (set in the Hire
 * admin) is Halloween and it is the season. Decided once per mount so the layout never flips
 * while the page is open.
 */
export const useIsHalloweenSignin = () => {
  const seasonalTheme = useSeasonalTheme();
  const [isEnabled] = useState(() => {
    return isHalloweenSigninEnabled({ now: new Date(), seasonalTheme });
  });
  return isEnabled;
};
